import React, { useState } from "react";
import { toast,  } from "react-hot-toast";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const RecomiendaBox = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [showReferidos, setShowReferidos] = useState(false);

  const handleCopiar = () => {
    navigator.clipboard.writeText(user?.codigo_ref);
    toast.dismiss();
    toast.success("¡Código copiado!");
  };

  return (
    <>
    <div className="recomienda-box"  onClick={() => navigate(`/eventos`)}>
            <div className="recomienda-texto">
                <img src="/assets/images/eventos.png"/>
                <h3>¿Qué se arma hoy?</h3>
                <p>Desde conciertos, ferias y festivales hasta planes tranquilos. Explorá lo más vibrante y único que Xela tiene para ti.</p>
                <b className="bold bt">
                    <svg className="recomienda-svg" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 16"><path fill="currentColor" d="M8.499 7.5a.5.5 0 1 0-1 0v3a.5.5 0 0 0 1 0zm.25-2a.749.749 0 1 1-1.499 0a.749.749 0 0 1 1.498 0M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1M2 8a6 6 0 1 1 12 0A6 6 0 0 1 2 8"/></svg>
                    Presiona para conocer eventos
                </b>
            </div>
        </div>
        {showReferidos && (
            <div className="referidos-overlay" onClick={() => setShowReferidos(false)}>
            <div className="referidos-modal" onClick={(e) => e.stopPropagation()}>
                <img className="referidos-foto" src={"/assets/images/5.png"} alt="Usuario" />
                <h3 className="referidos-nombre">¡Gana dinero por referir comercios!</h3>
                <small className="referidos-info">
                    Comparte tu código de referido y gana Q15 por cada comercio que se registre con tu código.
                </small>
                {user?.codigo_ref ? (
                    <div className="referidos-codigo">
                        <code>{user.codigo_ref}</code>
                        <button className="referidos-copy" onClick={handleCopiar}>
                        Copiar
                        </button>
                    </div>
                    ) : (
                    <p className="referidos-iniciar">
                        <strong>Inicia sesión</strong> para obtener tu código de referido.
                    </p>
                    )}
                <button className="referidos-cerrar" onClick={() => setShowReferidos(false)}>CERRAR</button>
            </div>
            </div>
        )}
    </>
  );
};

export default RecomiendaBox;
